export const USER_PERMISSIONS = {
  SUPER_ADMIN: 'superAdmin',
  ORGANISATION_ADMIN: 'organisationAdmin',
  USER: 'user',
};

export const USER_PERMISSIONS_LABELS = {
  [USER_PERMISSIONS.SUPER_ADMIN]: 'Super Admin',
  [USER_PERMISSIONS.ORGANISATION_ADMIN]: 'Organisation Admin',
  [USER_PERMISSIONS.USER]: 'Teammate',
};

export const USER_PERMISSIONS_INFO_LABEL = {
  [USER_PERMISSIONS.SUPER_ADMIN]: 'Super Admin',
  [USER_PERMISSIONS.ORGANISATION_ADMIN]: 'Org Admin',
  [USER_PERMISSIONS.USER]: 'Teammate',
};

export const USER_PERMISSIONS_CAPTIONS = {
  title: 'Make sure you select the correct user type for security purposes.',
  [USER_PERMISSIONS.USER]:
    'Teammate’s are the standard user type that can only access projects they have been added to.',
  [USER_PERMISSIONS.ORGANISATION_ADMIN]:
    'Organisation Admins have the highest level of access to manage users and all projects.',
};
